import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BienvenidaComponent } from './pages/bienvenida/bienvenida.component';
import { FinalizadoComponent } from './pages/finalizado/finalizado.component';
import { VideoconsultaComponent } from './pages/videoconsulta/videoconsulta.component';

const routes: Routes = [
  { 
    path: 'bienvenido',
    component: BienvenidaComponent
  },
  {
    path: 'videoconsulta',
    component: VideoconsultaComponent
  },
  {
    path: 'finalizado',
    component: FinalizadoComponent
  },
  { path: '**', component: FinalizadoComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
